import { Circle, Palette } from '@mui/icons-material';
import { ListItemIcon, Menu, MenuItem, SxProps, Theme, useTheme } from '@mui/material';
import { FC, useState } from 'react';
import { NoteHelper } from '@/util/note';
import IconButton from '@/components/common/IconButton';

export type Color = {
  value: string;
  label: string;
};

type ColorPickerProps = {
  colors: Color[];
  onChange: (color: string) => void;
  sx?: SxProps<Theme>;
};

const ColorPicker: FC<ColorPickerProps> = (props) => {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const theme = useTheme();

  // const noteColor = NoteHelper.getColor(
  //   data.details?.color,
  //   theme.palette.mode === 'dark' ? 600 : 300
  // );

  return (
    <>
      <IconButton onClick={(e) => setAnchor(e.currentTarget)} size='small' tooltip='Color'>
        <Palette fontSize='small' sx={props.sx} />
      </IconButton>
      <Menu id='bla' anchorEl={anchor} keepMounted open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {props.colors.map((color, index) => {
          return (
            <MenuItem key={`colors.${index}`} onClick={() => props.onChange(color.value)}>
              <ListItemIcon>
                <Circle
                  sx={{
                    color: NoteHelper.getColor(color.value, theme.palette.mode === 'dark' ? 600 : 300),
                    border: `1px solid ${theme.palette.text.primary}`,
                    borderRadius: 5
                  }}
                />
              </ListItemIcon>
              {color.label}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default ColorPicker;
